import { useCallback, useEffect, useState } from 'react';

import {
  AutocompleteUniteFOResultDtoFieldEnum,
  ReferenceDtoUniteFOResponseDto,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useHandleBackErrors } from 'hooks/utils/handleBackErrors';

type RefUniteDtoType = ReferenceDtoUniteFOResponseDto | undefined;
type RefUniteDtoFetcher = (str: string) => void;

export const useRefUniteFoSearch = (
  search: string | undefined = undefined,
  field: AutocompleteUniteFOResultDtoFieldEnum = AutocompleteUniteFOResultDtoFieldEnum.ABREVIATION,
  isFilteredByProfile = false,
  callApi = true,
): [RefUniteDtoType, string | undefined, boolean, RefUniteDtoFetcher] => {
  const behaviourOnError = useHandleBackErrors();

  const [searched, setSearched] = useState<string | undefined>(search);
  const [fetching, setFetching] = useState<boolean>(false);
  const [refUniteFo, setRefUniteFo] = useState<RefUniteDtoType>(undefined);
  const referentielControllerApi = useApi().ReferentielControllerApi;

  useEffect(() => {
    let cancel = false;
    if (searched === undefined || searched === '') {
      setFetching(false);
      return;
    }

    referentielControllerApi
      .searchedValidUniteFOUsingGET({ field, searched, isFilteredByProfile })
      .then(fetchedRef => {
        if (cancel) {
          return;
        }

        setFetching(false);
        setRefUniteFo(fetchedRef.reference);
      })
      .catch((errorResponse: Response) => {
        if (cancel) {
          return;
        }

        setFetching(false);
        behaviourOnError(errorResponse);
      });

    return () => {
      cancel = true;
    };
  }, [
    referentielControllerApi,
    behaviourOnError,
    callApi,
    searched,
    field,
    isFilteredByProfile,
  ]);

  const fetch = useCallback(
    (str: string) => {
      setFetching(true);
      setSearched(encodeURIComponent(str));
      setRefUniteFo(undefined);
    },
    [setSearched, setRefUniteFo],
  );

  return [refUniteFo, searched, fetching, fetch];
};
